import React, { useCallback, useState, useEffect } from 'react';
import { Globals, updateElementFocus } from '../../../misc/helpers';
import MenuIcon from './MenuIcon';
import MenuModal from './MenuModal';
import BleedoutTimer from './BleedoutTimer';
import LearningReviewModal from './LearningReviewModal';
import GeneralButton, { IGeneralButton } from './GeneralButton';
import { customRouter } from '../../../CustomRouter';
import { Windows } from '../../../pages/MainPage';

const PauseMenu = (props: any) => {
	const [isModalActive, setIsModalActive] = useState(false);
	const [isReviewModalActive, setIsReviewModalActive] = useState(false);
	const [isTimerActive, setIsTimerActive] = useState(true);
	const [isModal2Active, setIsModal2Active] = useState(false);

	const menuClickCallback = useCallback(() => {
		setIsTimerActive(false);
		setIsModalActive(true);
		setIsModal2Active(false);
	}, [isTimerActive, isModalActive, isModal2Active]);

	const closeMenuCallback = useCallback(() => {
		setIsTimerActive(true);
		setIsModalActive(false);
		setIsModal2Active(false);
	}, [isTimerActive, isModalActive, isModal2Active]);

	const menuClickCallback2 = useCallback(() => {
		setIsTimerActive(false);
		setIsModalActive(false);
		setIsModal2Active(true);
	}, [isTimerActive, isModalActive, isModal2Active]);

	const modalButtons: IGeneralButton[] = [
		{ text: 'resume', onClick: () => {
			window.document.removeEventListener('keydown', handleKey); 
			closeMenuCallback(); 
		}},
		{ text: 'return to main menu', onClick: menuClickCallback2 },
		{ text: 'review', onClick: () => { 
			setIsReviewModalActive(true);
		} },
	];
	
	const modal2Buttons: IGeneralButton[] = [
		//{ text: 'Yes', onClick: () => window.location.href = process.env.PUBLIC_URL },
		{ text: 'Yes', onClick: () => props.updateWindow(Windows.MainMenu) },
		{ text: 'No', onClick: menuClickCallback },
	];

	const btnStyle = { margin: '0 1.5%', minWidth: '30%' };
	const generalButtons = (modalButtons).map(({ text, onClick }) => {
		return (
			<GeneralButton key={text} text={text} onClick={onClick} style={btnStyle} />
		);
	});

	const btn2Style = { margin: '0 1.5%', minWidth: '47%' };
	const confirmButtons = (modal2Buttons).map(({ text, onClick }) => {
		return (
			<GeneralButton key={text} text={text} onClick={onClick} style={btn2Style} />
		);
	});

	props.timerParams.isActive = isTimerActive;

	const handleKey = useCallback((e: any) => {
		if (e.keyCode === 9) {//focus trap to prevent tabbing throught the element behind the popup
			let focusableParent = document.querySelector('.pause-modal-background');
			if(!focusableParent) return;

			let focusable = Array.prototype.slice.call(focusableParent.querySelectorAll('.modal-container-title p'))
			.concat(Array.prototype.slice.call(focusableParent.querySelectorAll('.general-btn-background')));

			updateElementFocus(e, focusable);
		}
	}, []);

	if (isModal2Active) {
		return (
			<div className="ui-top-most-container modal-disable-select">
				<BleedoutTimer parameters={props.timerParams}></BleedoutTimer>
				<MenuModal
					title="Return to the main menu?"
					isActive={isModal2Active}
					forceUpdate={true}
					handleKey={handleKey}>
					{confirmButtons}
				</MenuModal>
				<MenuIcon onClick={menuClickCallback2} />
			</div>);
	}

	else {
		return (
			<div className="ui-top-most-container modal-disable-select">
				<BleedoutTimer parameters={props.timerParams}></BleedoutTimer>
				<MenuModal
					title="Pause Menu"
					handleKey={handleKey}
					isActive={isModalActive}>
					{generalButtons}
				</MenuModal>
				<LearningReviewModal
					displayed={isReviewModalActive}
					closeLearningReview={() => {
						setIsReviewModalActive(false);
					}}
				/>
				<MenuIcon onClick={menuClickCallback} />
			</div>);
	}

};

export default PauseMenu;